
import IllinoisIcons from './icons.vue';
export default {
  name: 'IllinoisCounter',
  components: {
    IllinoisIcons
  },
  props: {
    title: {
      type: String,
      required: false
    },
    value: {
      type: Number,
      required: true,
      default: 0
    },
    max: {
      type: Number,
      required: false
    },
    min: {
      type: Number,
      required: false
    },
    disableIncrement: {
      type: Boolean,
      required: false,
      default: false
    },
    disableDecrement: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    decrement(): void {
      if (this.min === undefined || this.value > this.min) {
        this.$emit('input', this.value - 1);
      }
    },
    increment(): void {
      if (this.max === undefined || this.value < this.max) {
        this.$emit('input', this.value + 1);
      }
    }
  }
};
